import Vue from 'vue'

import type { ScriptColumnInitObject } from '@/models/scripts'

interface Computed {
  value: string | number
}

interface Props {
  init: ScriptColumnInitObject
}

export default Vue.extend<{}, {}, Computed, Props>({
  props: {
    init: {
      required: true,
    },
  },

  computed: {
    value(): string | number {
      return this.init.value ?? ''
    },
  },
})
